<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit Company</h2>
    </div>
  </div>
  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Company name'"
          [placeholder]="'Company Name'"
          [type]="'text'"
          [(value)]="company.company_name"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Organisation number'"
          [placeholder]="'Organisation number'"
          [type]="'text'"
          [(value)]="company.organisation_number"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Email'"
          [placeholder]="'Email'"
          [type]="'email'"
          [(value)]="company.email"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Phone'"
          [placeholder]="'Phone'"
          [type]="'tel'"
          [(value)]="company.phone"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Country'"
          [placeholder]="'Country'"
          [type]="'text'"
          [(value)]="company.country"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Address'"
          [placeholder]="'Address'"
          [type]="'text'"
          [(value)]="company.address"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'City'"
          [placeholder]="'City'"
          [type]="'text'"
          [(value)]="company.city"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Postal code'"
          [placeholder]="'Postal code'"
          [type]="'number'"
          [(value)]="company.postal_code"
        />
      </div>
    </div>
<!--    <div class="row g-4 spacing-15">-->
<!--      <div class="col-lg-6 col-12">-->
<!--        <app-input-component-->
<!--          [label]="'Email'"-->
<!--          [placeholder]="'Email'"-->
<!--          [type]="'email'"-->
<!--          [(value)]="user.email"-->
<!--        />-->
<!--      </div>-->
<!--      <div class="col-lg-6 col-12">-->
<!--        <app-input-component-->
<!--          [label]="'Phone'"-->
<!--          [placeholder]="'Phone'"-->
<!--          [type]="'tel'"-->
<!--          [(value)]="user.phone"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
    <div class="row g-4 spacing-15">
      <div class="col-lg-12 col-12">
        <app-markdown-editorini
          [value]="company.description"
          (valueChange)="company.description = $event"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-button
      [label]="'Save'"
      [variant]="'primary'"
      (clicked)="save()"
    />
  </div>
</div>
